import React, { useContext, useEffect, useState } from 'react';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import ImageComponent from 'atoms/Image';
import { getFullImagePath, getMainImagePath, getTernaryValue, isMobileDevice, throttle } from 'common/utilities/utils';
import {
  checkCategoryAvailability,
  getDynamicMenuAlertType,
} from 'molecules/DynamicMenuAlert/AU/Utils/DynamicMenuAlertUtils';
import { Link } from 'react-router-dom';
import { UserOrderContext } from '../../../context/context';
import START_ORDER_CONSTANTS from '../../StartOrderComponent/Constants/startOrderConstants';
import { DYNAMIC_MENU_CONSTANTS, LOCAL_STORAGE_KEYS, RESIZE, ROUTE_URL, FINGER_LICKIN } from 'common/constants/SharedConstants';
import { useSelector } from 'react-redux';

const BrowseMenuCategoryItems = props => {
  const contentReducer = useSelector(data => data?.contentReducer?.response?.homeContentfulResp);
  const fingerLickIn = contentReducer?.filter(logo => {
    return logo.fields?.title === FINGER_LICKIN
  });
  
  const fingerLickInLogo = fingerLickIn?.[0]?.fields?.image?.fields?.file?.url ?? ''
  const { data, tenantData, imagesize, baseUrl } = props;
  const { userOrderStateDispatch, userOrderState } = useContext(UserOrderContext);
  const [isMobile, setIsMobile] = useState(isMobileDevice(window.innerWidth));
  const [isCatering, setIsCatering] = useState(false);
  const { SELECTED_TILE_DATA = '' } = START_ORDER_CONSTANTS;
  const { fingerlickingDesk } = IMAGE_PATH;
  const { timeBasedCetegory } = userOrderState;

  useEffect(() => {
    if (baseUrl === ROUTE_URL.CATERING_PAGE) {
      setIsCatering(true);
    } else {
      setIsCatering(false);
    }
  }, [baseUrl]);
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setIsMobile(isMobileView);
  };
  const onResize = throttle(windowResized, 500);

  useEffect(() => {
    window.addEventListener(RESIZE, onResize);
    return () => {
      window.removeEventListener(RESIZE, onResize);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);

  const getContainerClassName = index => {
    if (index === 0) {
      return 'browse-lto';
    } else {
      return 'browse-item';
    }
  };
  const getImageClassName = index => {
    if (index === 0) {
      return 'browse-lto-img';
    } else {
      return 'browse-item-img';
    }
  };
  const getTileClassName = index => {
    if (index === 0) {
      return 'browse-lto-name';
    } else {
      return 'browse-item-name';
    }
  };

  const getHeadingClassName = index => {
    if (index === 0) {
      return 'browse-lto-heading';
    } else {
      return 'browse-item-heading';
    }
  };

  const productClickHandler = (event, selectedItem) => {
    const categoryExpried = checkCategoryAvailability(
      {
        categoryUrl: selectedItem?.url,
        itemInCart: userOrderState?.timeBasedCetegory?.timebasedItemInCart,
        alertType: getDynamicMenuAlertType(
          userOrderState?.timeBasedCetegory?.timebasedItemInCart,
          DYNAMIC_MENU_CONSTANTS?.CATEGORY,
        ),
      },
      timeBasedCetegory,
      userOrderStateDispatch,
    );
    if (categoryExpried) {
      event?.stopPropagation();
      event?.preventDefault();
      return;
    }

    let itemName = {
      name: selectedItem.name,
    };
    //selected tile from setState
    if (Object.keys(selectedItem).length === 0) {
      itemName = {};
    }

    userOrderStateDispatch({ type: SELECTED_TILE_DATA, value: { selectedData: itemName } });
    localStorage.setItem(LOCAL_STORAGE_KEYS.SELECTED_TILE, JSON.stringify(itemName));
    localStorage.setItem(LOCAL_STORAGE_KEYS.TENANT_REDUCER, JSON.stringify(tenantData));
  };

  const plpProductImageSopac = (imageContent, index, image_size) => {
    const imageHeight = getTernaryValue(
      index === 0,
      image_size?.imageHeight?.firstItem,
      image_size?.imageHeight?.restItem,
    );
    const imageWidth = getTernaryValue(index === 0, image_size?.imageWidth?.firstItem, image_size?.imageWidth?.restItem);
    return getMainImagePath(imageContent, imageWidth, imageHeight);
  };
  const gridStart = `${data.length % 4}`;
  const getFingerlickingStyle = () => {
    return gridStart === '0' ? 'auto' : gridStart;
  };
  const fingerlickingStyle = getFingerlickingStyle();
  const checkGridStartAndisMobileValid = () => {
    return isMobile || gridStart === '0';
  };
  const checkIsCateringValid = () => {
    return isCatering ? fingerLickInLogo : fingerlickingDesk;
  };
  const getFinglickingImage = () => {
    return checkGridStartAndisMobileValid() ? fingerLickInLogo : checkIsCateringValid();
  };
  const finglickingImage = getFinglickingImage();
  return (
    <div className='browse-menu-item-container'>
      {data?.map((item, index) => {
        return (
          <Link
            className={getContainerClassName(index)}
            data-testid='category-tile'
            to={`${baseUrl}/${item?.url}`}
            onClick={event => productClickHandler(event, item)}
            key={item.key}
          >
            <ImageComponent
              defaultPath={getFullImagePath(null, tenantData, true)}
              srcFile={plpProductImageSopac(item?.imageContent, index, imagesize)}
              className={getImageClassName(index)}
            />
            <div className={getTileClassName(index)}>
              <span className={getHeadingClassName(index)}>{item?.dname[0].value}</span>
            </div>
          </Link>
        );
      })}
      <Link
        className={`${getTernaryValue(
          isCatering,
          'browse-fingerlicking-desk catering-fingerlicking',
          'browse-fingerlicking',
        )}`}
        data-testid='fingerlicking-tile'
        to={baseUrl}
        onClick={event => productClickHandler(event, {})}
        style={{ gridColumnStart: fingerlickingStyle }}
      >
        <ImageComponent
          data-testid='fingerlicking-tile-img'
          defaultPath={fingerlickingDesk}
          srcFile={finglickingImage}
          className={`${getTernaryValue(
            isCatering,
            'browse-fingerlicking-desk catrening-fingerdesk',
            'browse-fingerlicking-desk',
          )}`}
        />
      </Link>
    </div>
  );
};

export default BrowseMenuCategoryItems;
